
import { computed, defineComponent, ref } from "vue";
import { NCheckbox, NCheckboxGroup } from "naive-ui";
import { MaterialModel, GroupModel } from "@/api/apiModel";
import useClipboard from "vue-clipboard3";
import { ElMessage } from "element-plus";
import { uploadModel, getGroupList } from "@/api/group";

export default defineComponent({
  name: "MixPane",
  props: {
    textListProp: {
      type: Array,
      require: true,
    },
  },
  components: { NCheckbox, NCheckboxGroup },
  setup(props, context) {
    const mixList = computed(() => {
      return (
        props.textListProp?.filter((x: any) => x.mouldType == "图文") || []
      );
    });

    // 编辑
    const editMix = (value: MaterialModel) => {
      context.emit("editMix", value);
    };
    // 删除
    const deleteText = () => {
      context.emit("deleteMix", checkList);
      checkList.value = [];
    };
    // 预览
    let isShowPreview = ref(false);
    const { toClipboard } = useClipboard();
    let previewValue = ref("");
    const preview = (value: MaterialModel) => {
      isShowPreview.value = true;
      previewValue.value = value.mould;
    };
    const copyContent = async () => {
      await toClipboard(previewValue.value);
      ElMessage.success("已复制");
      isShowPreview.value = false;
    };

    // 多选操作
    let isChooseAll = ref(false);
    let checkList = ref<Array<any>>([]);
    const chooseAll = (value: boolean) => {
      if (value) {
        isChooseAll.value = true;
        if (mixList.value != undefined) {
          checkList.value = [];
          for (let i of mixList.value) {
            checkList.value.push(i);
          }
          checkList.value = checkList.value.map((x) => x.id);
        }
      } else {
        isChooseAll.value = false;
        checkList.value = [];
      }
    };
    const handleUpdateValue = (value: Array<string>) => {
      checkList.value = value;
    };
    const getCount = () => {
      if (checkList.value == undefined) {
        return 0;
      }
      return checkList.value?.length;
    };

    // 移动
    let isShowMove = ref(false);
    let moveSelect = ref<GroupModel>({
      id: "",
      mouldGroupName: "",
      mouldGroupType: "图文",
      num: 0,
    });
    let groupList = ref<Array<GroupModel>>();
    // 获取分组列表
    const showMoveDialog = async () => {
      isShowMove.value = true;
      const res = await getGroupList();
      if (res.code == 200) {
        groupList.value = res.data?.filter(
          (x: GroupModel) => x.mouldGroupType == "图文"
        );
      }
    };
    // 选中
    const chooseMove = (item: GroupModel) => {
      moveSelect.value = item;
    };
    // 移动
    const move = async () => {
      try {
        for (let id of checkList.value) {
          let mouldList = mixList.value.filter(
            (x: any) => x.id == id
          ) as Array<MaterialModel>;
          if (mouldList[0] != undefined) {
            mouldList[0].mouldGroupId = moveSelect.value.id;
            mouldList[0].mouldGroupName = moveSelect.value.mouldGroupName;
          }
          await uploadModel(mouldList[0]);
        }
        ElMessage.success("移动成功");
        cancelMove();
        checkList.value = [];
        context.emit("refreshList");
      } catch (e) {
        ElMessage.error("移动失败" + e);
      }
    };
    // 取消
    const cancelMove = () => {
      moveSelect.value = {
        id: "",
        mouldGroupName: "",
        mouldGroupType: "图文",
        num: 0,
      };
      isShowMove.value = false;
    };

    return {
      mixList,
      isChooseAll,
      editMix,
      chooseAll,
      handleUpdateValue,
      getCount,
      checkList,
      deleteText,
      preview,
      isShowPreview,
      previewValue,
      copyContent,
      showMoveDialog,
      isShowMove,
      groupList,
      moveSelect,
      chooseMove,
      move,
      cancelMove,
    };
  },
});
